import Component from "@base/Component.js";
import config from "@/config.js";
import router from "@/services/router.js";
import t from "@/services/translationService.js";
import GallerySlideshow from "./GallerySlideshow.js";
import MapView from "./MapView.js";

/**
 * Gallery detail: heading + thumbnail grid + (when the gallery has a map) a
 * diagonal-split "diptych" at the bottom — story text in the upper-left triangle,
 * map in the lower-right. Hovering (or tapping) a side expands it.
 * props: { gallery: GalleryObject, lang, onLeave() }
 */
export default class GalleryDetail extends Component {
  render() {
    const { gallery: g, lang } = this.props;
    const thumbs = (g.images || [])
      .map(
        (img, i) => `
        <button class="thumb" data-index="${i}">
          <img src="${config.imageBase}/${encodeURIComponent(g.galleryId)}/${encodeURIComponent(img.name)}?size=thumb"
               alt="${Component.escape(g.title(lang))} ${i + 1}" loading="lazy" />
        </button>`
      )
      .join("");

    const hasMap = g.placeIds().length > 0;
    const content = g.content(lang);
    const hasText = Boolean(content && String(content).trim());

    const textPanel = `
      <div class="diptych__panel diptych__text">
        <div class="diptych__inner">
          <span class="diptych__label">${t.t("gallery.story")}</span>
          <div class="diptych__text-body">${Component.escape(content)}</div>
        </div>
      </div>`;
    const mapPanel = `
      <div class="diptych__panel diptych__map">
        <span class="diptych__label diptych__label--map">${t.t("gallery.map")}</span>
        <div class="map-slot"></div>
      </div>`;

    // Bottom area: both → diagonal diptych; only one → that panel full-width; none → nothing.
    let bottom = "";
    if (hasText && hasMap) bottom = `<div class="diptych">${textPanel}${mapPanel}</div>`;
    else if (hasMap) bottom = `<div class="diptych diptych--single">${mapPanel}</div>`;
    else if (hasText) bottom = `<div class="diptych diptych--single diptych--text">${textPanel}</div>`;

    return `
      <article class="gallery-detail">
        <a class="back-link" href="#/">&#8249; ${t.t("gallery.back")}</a>
        <header class="gallery-detail__head">
          <h1>${Component.escape(g.title(lang))}</h1>
          <p class="gallery-detail__subtitle">${Component.escape(g.subtitle(lang))}</p>
        </header>
        <div class="thumb-grid">${thumbs}</div>
        ${bottom}
      </article>`;
  }

  onMounted() {
    const g = this.props.gallery;

    if (g.placeIds().length) {
      this.mountChild(MapView, { placeIds: g.placeIds(), zoomLevel: g.zoomLevel }, this.$(".map-slot"));
    }

    this.$$(".thumb").forEach((btn) => {
      this.listen(btn, "click", () => {
        new GallerySlideshow({
          galleryId: g.galleryId,
          images: g.images || [],
          startIndex: Number(btn.getAttribute("data-index")) || 0,
          alt: g.title(this.props.lang),
        }).mount(document.body);
      });
    });

    // Diptych: desktop expands on hover (CSS); tapping pins a side (mobile /
    // click-to-lock). The map itself stays draggable — only its label pins it.
    // The diptych expands on hover (CSS) — the titles are just labels, not buttons.

    this.listen(this.$(".back-link"), "click", (e) => {
      e.preventDefault();
      router.go("/");
    });
  }

  /** Fires on route change — closes out the visit the controller opened. */
  onBeforeUnmount() {
    this.props.onLeave?.();
  }
}
